/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon30Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g stroke={"#292929"} strokeLinejoin={"round"} clipPath={"url(#a)"}>
        <path
          strokeLinecap={"round"}
          d={
            "M12 16.875h4.875v-7.5a.62.62 0 0 0-.183-.442l-6.25-6.25a.626.626 0 0 0-.884 0l-6.25 6.25a.63.63 0 0 0-.183.442v7.5H8"
          }
        ></path>

        <path d={"M8 17v-6h4v6"}></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon30Icon;
/* prettier-ignore-end */
